import './index.less';
import React from 'react';
import { Tabs } from 'antd';

const TabPane = Tabs.TabPane;
const week = {
  0: '星期日',
  1: '星期一',
  2: '星期二',
  3: '星期三',
  4: '星期四',
  5: '星期五',
  6: '星期六'
}
const englishweek = {
  0: 'SUN',
  1: 'MON',
  2: 'TUES',
  3: 'WED',
  4: 'THUR',
  5: 'FRI',
  6: 'SAT'
}

class TimeList extends React.Component{

	constructor(props) {
	  super(props);
	
	  this.state = {};
	}

  callback = (key) => {
    const { callback } = this.props;
    callback(key);
  }

  tabPane = (key, index) => {
    return (
      <TabPane key={key} tab={
        <div className='timeList-tab'>
          <p>{week[index]}</p>
          <p>{englishweek[index]}</p>
        </div>
      }>{this.renderSchedule(index)}</TabPane>
    )
  }

  renderTab = () => {
    let tem = '';
    const dom = [];
    const { weeks, type } = this.props;
    const arr = Object.keys(weeks);
    if (!type) {
      for (let i = 0; i < arr.length; i += 1) {
        if (arr[i] === '0') {
          tem = this.tabPane(arr.length - 1, arr[i]);
          continue;
        }
        if (tem) {
          dom.push(this.tabPane(i - 1, arr[i]))
        } else {
          dom.push(this.tabPane(i, arr[i]))
        }
      }
      if (tem) {
        dom.push(tem);
      }
    } else {
      for (let i = 0; i < arr.length; i += 1) {
        dom.push(<TabPane key={i} tab={
          <div className='timeList-tab'>
            <p>{this.date(arr[i])}</p>
            <p>{this.week(arr[i])}</p>
          </div>
        }>{this.renderSchedule(arr[i])}</TabPane>)
      }
    }
    return dom;
  }

  date = (date) => {
    return date.substr(-5, 5);
  }

  week = (date) => {
    const d = new Date(date);
    switch (d.getDay()) {
      case 0:
        return '星期日';
      case 1:
        return '星期一';
      case 2:
        return '星期二';
      case 3:
        return '星期三';
      case 4:
        return '星期四';
      case 5:
        return '星期五';
      case 6:
        return '星期六';
      default: break;
    }
  }

  renderSchedule = (index) => {
    let arr = '';
    const dom = [];
    const { weeks } = this.props;
    if (Array.isArray(weeks[index])) {
      arr = weeks[index].sort((x,y) => {
        return x-y;
      })
    } else {
      arr = Object.keys(weeks[index].times);
    }
    for ( let i = 0; i < arr.length; i += 1) {
      dom.push(<div key={i} className={this.selectStatus(index, arr[i])} onClick={() => this.selectTime(index, arr[i])}>{this.clock(arr[i])}</div>)
    }
    return dom;
  }

  selectStatus = (week, time) => {
    let Class = 'timeList-timeBtn';
    const { course } = this.props;
    for (let i = 0; i < course.length; i += 1) {
      if (course[i].week === week && course[i].time === time) {
        Class = 'timeList-timeBtn timeList-select'
        break;
      }
    }
    return Class;
  }

  selectTime = (week, time) => {
    const { num } = this.props;
    const len = num ? parseInt(num, 10) : 2;
    let flag = {
      status: false,
      index: -1,
    };
    const { course, selectTime } = this.props;
    for (let i = 0; i < course.length; i += 1) {
      if (course[i].week === week && course[i].time === time) {
        flag = {
          status: true,
          index: i
        };
        break;
      }
    }
    let tem = course;
    if (len === 1) {
      tem = [{
        week: week,
        time: time
      }]
    } else {
      if (flag.status) {
        tem.splice(flag.index, 1);
      } else {
        if (len === tem.length) {
          tem.shift();
        }
        tem.push({
          week: week,
          time: time
        })
      }
    }
    selectTime(tem);
  }

  clock = (time) => {
    const h = Math.floor(time/2);
    return !(time % 2) ? (h + ':00') : (h + ':30');
  }

  render(){
    const { defaultIndex } = this.props;
    return (
      <div className='timeList'>
        <Tabs defaultActiveKey={defaultIndex} onChange={this.callback}>
          {
            this.renderTab()
          }
        </Tabs>
      </div>
    )
  }
}

export default TimeList


// WEBPACK FOOTER //
// ./src/components/timeList/timeList.jsx